import React from 'react';
import { LivingHero } from '../../components/living/LivingHero';
import { LivingCategories } from '../../components/living/LivingCategories';
import { LivingCraft } from '../../components/living/LivingCraft';
import { ProductSection } from '../../components/shop/ProductSection';
import { livingProducts } from '../../data/livingProducts';
import { site } from '../../data/site';
import { useSeo } from '../../hooks/useSeo';
import { images } from '../../data/images';
export function LivingHome() {
  useSeo({
    title: site.livingTitle,
    description: site.livingDescription,
    path: '/living',
    image: images.livingHero,
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'Store',
      name: site.livingName,
      url: `${site.url}/living`
    }
  });
  const popular = livingProducts.filter(p => p.badges.includes('bestseller')).slice(0, 4);
  const gifts = livingProducts.filter(p => p.badges.includes('cadeau')).slice(0, 4);
  return <>
      <LivingHero data-id="element-668" data-mp="2fj9qn5weu87n" />
      <div className="mt-14 bg-stone lg:mt-20" data-id="element-669" data-mp="2flw39jy5rdwq">
        <ProductSection tone="living" title="Populair bij AMIRA Living" subtitle="Onze meest verkochte stukken, direct uit voorraad leverbaar." link={{
        to: '/living/collectie/bestsellers',
        label: 'Bekijk alles'
      }} products={popular} data-id="element-670" data-mp="u91uae3u3lnv" />
      </div>
      <LivingCategories data-id="element-671" data-mp="188jm72cfff1g" />
      <LivingCraft data-id="element-672" data-mp="187rzyi4pytnu" />
      <ProductSection tone="living" title="Cadeaus uit Marokko" subtitle="Stijlvol verpakt, met een gratis kaartje voor jouw boodschap." link={{
      to: '/living/collectie/cadeaus',
      label: 'Alle cadeaus'
    }} products={gifts} data-id="element-673" data-mp="am44bzg38fdd" />
    </>;
}